export default "__VITE_ASSET__8Ljf6_7h__"